import React, { createContext, useContext, useReducer } from 'react';

export const SnackbarContext = createContext();

export const SnackbarProvider = ({ children, reducer, state }) => {
  return <SnackbarContext.Provider value={useReducer(reducer, state)}>{children}</SnackbarContext.Provider>;
};

export const useSnackbarContext = () => useContext(SnackbarContext);
